<template>
  <div>
    <!-- Header Section -->
    <v-app-bar
      color="grey darken-3"
      dark
      ap
      elevate-on-scroll
      scroll-target="#scrolling-content"
    >
      <v-container fluid>
        <v-row align="center">
          <v-col cols="12" md="4" class="d-flex align-center">
            <v-avatar color="success" class="mr-4">
              <v-icon large>mdi-package-variant</v-icon>
            </v-avatar>
            <div>
              <div class="text-h5 font-weight-bold">{{ pageTitle }}</div>
              <div class="text-caption">Manage your inventory items</div>
            </div>
          </v-col>

          <v-col cols="12" md="8" class="text-right">
            <v-btn
              v-can="'item.read'"
              color="white"
              outlined
              class="mr-2"
              :to="{name: 'items-vuetify'}"
            >
              <v-icon left>mdi-format-list-bulleted</v-icon>
              {{ $t('item.button.item') }}
            </v-btn>

            <v-btn
              v-can="'item.create'"
              color="success"
              @click="showCreateDialog"
              class="mr-2"
            >
              <v-icon left>mdi-plus</v-icon>
              {{ $t('item.button.create') }}
            </v-btn>

            <v-menu offset-y>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  color="white"
                  outlined
                  v-bind="attrs"
                  v-on="on"
                >
                  <v-icon>mdi-dots-vertical</v-icon>
                </v-btn>
              </template>
              <v-list dense>
                <v-list-item :to="{name: 'upload-items'}">
                  <v-list-item-icon>
                    <v-icon>mdi-upload-multiple</v-icon>
                  </v-list-item-icon>
                  <v-list-item-content>
                    <v-list-item-title>{{ $t('item.button.upload') }}</v-list-item-title>
                  </v-list-item-content>
                </v-list-item>

                <v-list-item @click="showBatchUploadDialog">
                  <v-list-item-icon>
                    <v-icon>mdi-image-multiple</v-icon>
                  </v-list-item-icon>
                  <v-list-item-content>
                    <v-list-item-title>{{ $t('item.button.batch_upload_images') }}</v-list-item-title>
                  </v-list-item-content>
                </v-list-item>

                <v-list-item :to="{name: 'labels'}">
                  <v-list-item-icon>
                    <v-icon>mdi-label</v-icon>
                  </v-list-item-icon>
                  <v-list-item-content>
                    <v-list-item-title>{{ $t('item.button.labels') }}</v-list-item-title>
                  </v-list-item-content>
                </v-list-item>

                <v-list-item :to="{name: 'old-labels'}">
                  <v-list-item-icon>
                    <v-icon>mdi-label-outline</v-icon>
                  </v-list-item-icon>
                  <v-list-item-content>
                    <v-list-item-title>{{ $t('item.button.labels_old') }}</v-list-item-title>
                  </v-list-item-content>
                </v-list-item>

                <v-divider></v-divider>

                <v-list-item :to="{name: 'items-archive'}">
                  <v-list-item-icon>
                    <v-icon>mdi-archive</v-icon>
                  </v-list-item-icon>
                  <v-list-item-content>
                    <v-list-item-title>{{ $t('button.archive') }}</v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
              </v-list>
            </v-menu>
          </v-col>
        </v-row>
      </v-container>
    </v-app-bar>

    <!-- Create/Edit Dialog -->
    <create-edit-item-vuetify
      @close="closeCreateDialog"
      :display="displayCreateDialog"
      @created="itemCreated"
    ></create-edit-item-vuetify>

    <!-- Batch Image Upload Dialog -->
    <batch-image-upload
      @close="closeBatchUploadDialog"
      :display="displayBatchUploadDialog"
    ></batch-image-upload>

    <!-- Router View -->
    <div id="scrolling-content" class="mt-">
      <transition name="slide-fade">
        <router-view @parent-title="updateTitle"/>
      </transition>
    </div>
  </div>
</template>

<script>
import CreateEditItemVuetify from './Modal/CreateEditItemVuetify'
import BatchImageUpload from './Modal/BatchImageUpload'

export default {
  name: 'ItemsVuetify',
  components: {
    CreateEditItemVuetify,
    BatchImageUpload
  },
  data () {
    return {
      pageTitle: '',
      displayCreateDialog: false,
      displayBatchUploadDialog: false
    }
  },
  methods: {
    updateTitle (title) {
      this.pageTitle = title
    },
    showCreateDialog () {
      this.displayCreateDialog = true
    },
    closeCreateDialog () {
      this.displayCreateDialog = false
    },
    showBatchUploadDialog () {
      this.displayBatchUploadDialog = true
    },
    closeBatchUploadDialog () {
      this.displayBatchUploadDialog = false
    },
    itemCreated (data) {
      this.$emit('new-item', data)
    }
  },
  async mounted () {
    this.$emit('parent-title', this.$t('item.title.item'))
  }
}
</script>

<style scoped>
.slide-fade-enter-active {
  transition: all 0.3s ease;
}
.slide-fade-leave-active {
  transition: all 0.2s cubic-bezier(1.0, 0.5, 0.8, 1.0);
}
.slide-fade-enter, .slide-fade-leave-to {
  transform: translateX(10px);
  opacity: 0;
}
</style>
